import { render, staticRenderFns } from "./HeroSearch.vue?vue&type=template&id=70a0b506&"
import script from "./HeroSearch.vue?vue&type=script&lang=js&"
export * from "./HeroSearch.vue?vue&type=script&lang=js&"
import style0 from "./HeroSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HeroSearch.vue"
export default component.exports